import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { flushedFocusVisible, outlineFocusVisible } from './focus-styles';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

export const Input = defineMultiStyleConfig({
	variants: {
		outline: {
			field: outlineFocusVisible,
		},
		filled: {
			field: outlineFocusVisible,
		},
		flushed: {
			field: flushedFocusVisible,
		},
	},
});
